// src/components/Navbar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import './Navbar.css';
import bImage from '../components/VerticalLogo.png';

function Navbar() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="navbar-wrapper sticky-top">
      <div className="top-bar container d-flex justify-content-between align-items-center">
        <Link to="/" className="navbar-brand" onClick={closeMobileMenu}>
          <img src={ bImage } alt="Investment Illustration"/>Cloudvisor Wealth
        </Link>
        
        {/* Desktop Contact Button */}
        <div className="desktop-contact-btn">
          <Link to="/contact" className="btn btn-outline-secondary me-2" 
          style={{ backgroundColor: '#bfd42f', border: '2px solid #bfd42f', color: '#000000' }}>
            Contact Us
          </Link>
        </div>

        {/* Mobile Hamburger Button */}
        <button 
          className="mobile-menu-toggle d-md-none"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
        </button>
      </div>

      <hr className="divider" />

      {/* Desktop Navigation */}
      <nav className="desktop-nav menu-bar container d-none d-md-block">
        <ul className="nav">
          <li className="nav-item">
            <Link
              to="/home"
              className={`custom-nav-link ${location.pathname === '/home' ? 'active' : ''}`}
            >
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/services"
              className={`custom-nav-link ${location.pathname === '/services' ? 'active' : ''}`}
            >
              Our Solution
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/difference"
              className={`custom-nav-link ${location.pathname === '/difference' ? 'active' : ''}`}
            >
              Our Company
            </Link>
          </li>
        </ul>
      </nav>

      {/* Mobile Navigation */}
      <nav className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
        {/* Overlay for closing menu */}
        <div 
          className="mobile-nav-overlay" 
          onClick={closeMobileMenu}
        ></div>
        
        <div className="mobile-menu-content">
          <ul className="mobile-nav-list">
            <li className="mobile-nav-item">
              <Link
                to="/home"
                className={`mobile-nav-link ${location.pathname === '/home' ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                Home
              </Link>
            </li>
            <li className="mobile-nav-item">
              <Link
                to="/services"
                className={`mobile-nav-link ${location.pathname === '/services' ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                Our Solution
              </Link>
            </li>
            <li className="mobile-nav-item">
              <Link
                to="/difference"
                className={`mobile-nav-link ${location.pathname === '/difference' ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                Our Company
              </Link>
            </li>
            <li className="mobile-nav-item">
              <Link
                to="/contact"
                className="mobile-nav-link mobile-contact-btn"
                onClick={closeMobileMenu}
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </nav>

      <hr className="divider" />
    </header>
  );
}

export default Navbar;